// NOTE: 상단 Banner 클릭 시나리오
import push from '@/utils/gaEvents/push'

import { BANNER_POSITION_CATEGORY } from '@/enums/gtagEvents'

const onClickBanner = (page: string) => {
  push({
    event: 'bannerClick',
    page: page,
    cate: BANNER_POSITION_CATEGORY.TOP
  } satisfies GtagBannerClickEvent)
}

const bannerEvent = {
  onClickBanner
}

export default bannerEvent
